'use client';

import { c as _c } from "react/compiler-runtime";
import type { GetCompetitionsRow } from '@morfi/backend-sdk-v2/client';
import { useGetCompetitions } from '@morfi/backend-sdk-v2/client';
import type { ReactNode } from 'react';
import type { CompetitionsListStatus } from '@/components/social/competition/competitions-list';
import { CompetitionsPage } from '@/components/social/competition/competitions-page';
import { useClientNowMs } from '@/components/social/competition/use-client-now';
import { useLiveListData } from '@/hooks/sdk/use-live-list-data';
import { toCompetitionSummaries } from '@/lib/competitions/from-sdk';
import type { CompetitionsPhaseFilter } from '@/lib/competitions/query-args';

/**
 * Competition list owner.
 *
 * Every published competition is read in one page and the delivered list
 * filters and counts the phases client-side — the phase pills need all four
 * counts, which a phase-filtered request cannot give. The read is the first
 * page of 20; when the archive outgrows that, the list needs its own paging
 * rather than a bigger page.
 */
export function CompetitionsListData(t0) {
  const $ = _c(14);
  const {
    initialPhase,
    timeZone
  } = t0;
  const initialNowMs = useClientNowMs();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const query = useGetCompetitions(t1);
  const rows = useLiveListData(query.queryKey);
  let T0;
  let competitions;
  let t2;
  if ($[1] !== query.isFetched || $[2] !== query.status || $[3] !== rows) {
    competitions = toCompetitionSummaries(rows);
    T0 = CompetitionsPage;
    t2 = listStatus(query.status, query.isFetched, competitions.length);
    $[1] = query.isFetched;
    $[2] = query.status;
    $[3] = rows;
    $[4] = T0;
    $[5] = competitions;
    $[6] = t2;
  } else {
    T0 = $[4];
    competitions = $[5];
    t2 = $[6];
  }
  let t3;
  if ($[7] !== T0 || $[8] !== competitions || $[9] !== initialNowMs || $[10] !== initialPhase || $[11] !== t2 || $[12] !== timeZone) {
    t3 = <T0 status={t2} initialPhase={initialPhase} initialNowMs={initialNowMs} timeZone={timeZone} competitions={competitions} />;
    $[7] = T0;
    $[8] = competitions;
    $[9] = initialNowMs;
    $[10] = initialPhase;
    $[11] = t2;
    $[12] = timeZone;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}
function listStatus(status: 'pending' | 'error' | 'success', isFetched: boolean, count: number): CompetitionsListStatus {
  if (status === 'error') return 'error';
  if (status !== 'success' || !isFetched) return 'loading';
  return count === 0 ? 'empty' : 'ready';
}